export const Nav = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
    else el.scrollIntoView({ behavior: "smooth" });
  };
  const scrollTop = () => {
    if (window.__lenis) window.__lenis.scrollTo(0);
    else window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <nav
      data-testid="site-nav"
      className="fixed top-0 left-0 right-0 z-40 border-b border-[#D8D4CA]/60 bg-[#F6F5F2]/80 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4 lg:px-10">
        <button data-testid="nav-logo" onClick={scrollTop} className="font-serif text-lg tracking-tight text-[#0A0F16]">
          Melanie Ann Collins
        </button>
        <div className="hidden items-center gap-8 text-xs font-medium uppercase tracking-[0.18em] text-[#4A525B] md:flex">
          <button data-testid="nav-scope" onClick={() => scrollTo("scope")} className="transition-colors duration-300 hover:text-[#0A0F16]">Scope</button>
          <button data-testid="nav-experience" onClick={() => scrollTo("experience")} className="transition-colors duration-300 hover:text-[#0A0F16]">Experience</button>
          <button data-testid="nav-credentials" onClick={() => scrollTo("credentials")} className="transition-colors duration-300 hover:text-[#0A0F16]">Credentials</button>
        </div>
        <a
          data-testid="nav-lets-talk-btn"
          href="mailto:collinsmelanie845@gmail.com"
          className="rounded-full bg-[#122336] px-5 py-2 text-xs font-semibold uppercase tracking-[0.15em] text-[#F6F5F2] transition-colors duration-300 hover:bg-[#D18237]"
        >
          Let's Talk
        </a>
      </div>
    </nav>
  );
};
